import {type Writable, writable} from "svelte/store";

/*
* [{unitId: [qualifications]}]
* */
export const qualifications:Writable<any> = writable([])